// @ts-nocheck
import React, { useState, useEffect } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import FormFileUpload from '../../common/FormFileUpload';
import { toast } from 'react-toastify';
import KwPanel from '../../common/KwPanel';
import Loading from '../../common/Loading';
import { useTranslation } from 'react-i18next';
import { getAccountDetails } from '../../../api/requestApi';
import { useAppDispatch } from '../../../hooks';
import { uploadAccountDetails } from '../../../reducers/basketReducer';
import AccountDetailsTable from '../components/AccountDetailsTable';
import Button from '../../common/Button';

export interface UploadAccountDetailsProps {
  done: (data: any) => void;
  cancel: () => void;
  id: any;
  downloadAccountDetailsTemplate: () => void;
  numberOfKeys: number;
  onUploadSuccess?: () => void;
}

const UploadAccountDetails = ({
  done,
  cancel,
  id,
  downloadAccountDetailsTemplate,
  numberOfKeys,
  onUploadSuccess,
}: UploadAccountDetailsProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [file, setFile] = useState<any>();
  const [accountDetails, setAccountDetails] = useState<any>();

  const addFiles = (files: any) => {
    setFile(files[0]);
  };

  const onUpload = () => {
    if (!file) {
      toast.error(t('Please select a file before clicking Upload'));
      return;
    }

    dispatch(uploadAccountDetails({ id, file }))
      .unwrap()
      .then((d) => {
        toast.success(t('Successfully uploaded account details'));
        setAccountDetails((prevState: any) => {
          const newState = [...(prevState || []), ...d];
          done(newState);
          return newState;
        });
        if (onUploadSuccess) {
          onUploadSuccess();
        }
      })
      .catch((e) =>
        toast.error(e.message || t('Failed to upload account details'))
      );
  };

  useEffect(() => {
    if (accountDetails) {
      return;
    }

    getAccountDetails(id)
      .then((data) => {
        setAccountDetails(data);
        setIsLoading(false);
      })
      .catch((e) => {
        toast.error(t('Failed to get account details'));
      });
  }, [accountDetails, id, t]);

  return (
    <SlideoutLayout title={t('Account details')} cancel={cancel}>
      {!isLoading ? (
        <>
          {numberOfKeys > accountDetails?.length && (
            <KwPanel className="mb-4">
              <header className="flex-wrap row-gap-5">
                <h2 className="flex-grow-1 flex-shrink-0 flex-basis-100">
                  {t('Upload remaining {number} accounts', {
                    number: numberOfKeys - accountDetails?.length,
                  })}
                </h2>
                <div className="d-flex flex-wrap col-gap-5 row-gap-5 flex-grow-1">
                  <Button
                    className="btn btn-default btn-xs-full"
                    onClick={downloadAccountDetailsTemplate}
                    text={t('Download account details template')}
                  />
                </div>
              </header>
              <FormFileUpload
                name="files"
                required
                errorMessage={t('Required')}
                label={t('Upload account details file')}
                fileExtension=".xlsx"
                addFiles={addFiles}
                removeFile={() => setFile(null)}
                files={file ? [file] : []}
              />
              <input
                type="submit"
                value={t('Upload')}
                className="btn btn-primary btn-xs-full mt-3"
                onClick={onUpload}
              />
            </KwPanel>
          )}
          {accountDetails && accountDetails.length > 0 && (
            <AccountDetailsTable request={{ id, numberOfKeys }} />
          )}
        </>
      ) : (
        <Loading />
      )}
    </SlideoutLayout>
  );
};

export default UploadAccountDetails;
